import React, { useState, useContext } from "react";
import {
  faExclamationTriangle,
  faTimesCircle,
  faTimes,
} from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Modal, Button } from "react-bootstrap";
import {
  deleteLoanRequest,
  deleteRollOverInRequest,
  deleteWithdrawalRequest,
} from "../../services";
import { get } from "lodash";
import {
  manageTransactionStore,
  setManageTransactionToastInfo,
} from "../../contexts";

const DeleteThisRequestModel = ({
  deleteEmployee,
  setDeleteEmployee,
  listEmployeeRolloverin,
  setListEmployeeRolloverin,
  show,
  onHide,
  filter,
  children,
  listEmployee,
  setListEmployee,
  setShowModal,
  toggle,
  setToggle,
  empName,
  employee,
  setAppend,
}) => {
  const { state, dispatch } = useContext(manageTransactionStore);
  var withdrawalType = deleteEmployee?.withdrawalType?.split(".");
  var withdrawalTypeLength = withdrawalType?.length - 1;

  var withdrawalTypeAnswer = get(withdrawalType, withdrawalTypeLength);

  const handleClick = (withdrawalRequestId, rolloverinid, loanId) => {
    if (filter === "Rolloverin") {
      deleteRollOverInRequest(rolloverinid).then((res) => {
        // let newList = listEmployee.filter((item) => item.id !== rolloverinid);
        // setListEmployee(newList);
        setAppend(false);
        setToggle(!toggle);
        setShowModal(false);
        dispatch(
          setManageTransactionToastInfo({
            showToast: true,
            toastMessage: "Rollover Request is Deleted",
            toastMessage1: get(deleteEmployee, "employeeName", ""),
            reject: true,
          })
        );
      });
    } else if (filter === "Loans") {
      deleteLoanRequest(loanId).then((res) => {
        setAppend(false);
        setToggle(!toggle);
        setShowModal(false);
        dispatch(
          setManageTransactionToastInfo({
            showToast: true,
            toastMessage: "Loans Request is Deleted",
            toastMessage1: get(deleteEmployee, "employeeName", ""),
            reject: true,
          })
        );
      });
    } else if (filter === "Withdrawals") {
      deleteWithdrawalRequest(withdrawalRequestId).then((res) => {
        setAppend(false);
        setToggle(!toggle);
        setShowModal(false);
        dispatch(
          setManageTransactionToastInfo({
            showToast: true,
            toastMessage: "Withdrawal Request is Deleted",
            toastMessage1: get(deleteEmployee, "employeeName", ""),
            toastMessage2: withdrawalTypeAnswer,
            reject: true,
          })
        );
      });
    }
  };
  return (
    <Modal show={show} onHide={onHide} size="smd">
      <Modal.Body>
        <div className="d-flex">
          <div className="pd-15">
            <FontAwesomeIcon
              icon={faExclamationTriangle}
              color="orange"
              size="3x"
              className="mt-3"
            />
          </div>
          <div className="remove-text">
            <h4>Delete This request?</h4>
            <p>Separation from service WithDrawal</p>
            <br />
            <Button
              variant="secondary"
              onClick={() => setShowModal(onHide)}
              className="ml-5 mr-3"
            >
              Cancel
            </Button>
            <Button
              variant="primary"
              style={{
                backgroundColor: "orange",
                color: "#fff",
                border: "2px solid orange",
              }}
              onClick={() => {
                handleClick(
                  get(deleteEmployee, "withdrawalRequestId"),
                  get(deleteEmployee, "id"),
                  get(deleteEmployee, "id")
                );

                //filter === 'Withdrawals' ?  handleClick(deleteEmployee.withdrawalRequestId) :   filter === 'Rolloverin' ?  handleClick(deleteEmployee.id) :  handleClick(deleteEmployee.id)
              }}
            >
              Yes,Delete
            </Button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default DeleteThisRequestModel;
